import { useState } from 'react';

import { AvatarButton, Text } from 'shell/components';
import theme from 'shell/themes';

const AvatarButtonDemo = () => {
    const [selected, setSelected] = useState('');

    const user1 = {
        id: '1',
        first_name: 'Georgina',
        last_name: 'Watson',
        profile_circle: {
            bg_Color: theme.palette.ensightful.error[800],
            text_color: theme.palette.ensightful.shades[0],
        },
    };
    const user2 = {
        id: '2',
        first_name: 'Mingyu',
        last_name: 'Gao',
        display_name: 'Ming',
        // profile_image: {
        //     bucket: 'ensightful-us-upload-app-develop-2',
        //     key: '85223ddf-cbe0-47a0-8091-ea7a8e64615a',
        //     name: 'orange.png',
        //     type: 'image/png',
        // },
    };

    return (
        <>
            <Text variant={'sh1'}>AvatarButton</Text>
            <AvatarButton
                selected={selected === user1.id}
                size={'medium'}
                user={user1}
                value={user1.id}
                onClick={setSelected}
            />
            <AvatarButton
                selected={selected === user2.id}
                size={'medium'}
                user={user2}
                value={user2.id}
                onClick={setSelected}
            />
        </>
    );
};

export default AvatarButtonDemo;
